import * as actions from './actionsTypes';

const initialData = {
  loaderWorkFlowBlockCheckLists: false,
  loaderWorkFlowBlockCheckList: false,
  saveLoaderWorkFlowBlockCheckList: false,
  saveLoaderWorkFlowBlockCheckListPosition: false,
  workflowBlockCheckListsLength: 0,
  workflowBlockCheckLists: [],
  workflowBlockCheckList: null,
  formErrorsWorkflowBlockCheckList: '',
  errorWorkflowBlockCheckList: '',
}

export default function workflowBlockCheckListReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_WORKFLOWBLOCK_CHECKLISTS:
      return {...state, loaderWorkFlowBlockCheckLists: action.payload}
    case actions.LOADING_WORKFLOWBLOCK_CHECKLIST:
      return {...state, loaderWorkFlowBlockCheckList: action.payload}
    case actions.SAVE_LOADING_WORKFLOWBLOCK_CHECKLIST:
      return {...state, saveLoaderWorkFlowBlockCheckList: action.payload}
    case actions.SAVE_LOADING_WORKFLOW_CHECKLIST_POSITION:
      return {...state, saveLoaderWorkFlowBlockCheckListPosition: action.payload}
    case actions.GET_WORKFLOWBLOCK_CHECKLISTS:
      return {...state, workflowBlockCheckLists: action.payload.workflowBlockCheckLists, workflowBlockCheckListsLength: action.payload.workflowBlockCheckListsLength}
    case actions.GET_WORKFLOWBLOCK_CHECKLIST:
      return {...state, workflowBlockCheckList: action.payload}
    case actions.WORKFLOWBLOCK_CHECKLIST_FAIL:
      return {...state, errorWorkflowBlockCheckList: action.payload}
    case actions.WORKFLOWBLOCK_CHECKLIST_FORM_FAIL:
      return {...state, formErrorsWorkflowBlockCheckList: action.payload}
    default:
      return state
  }
}